export const BaseSystems: { [key: number]: string } = {
  1: 'Базовая платформа',
};

export const enum PUBLICATION_DATE {
  ALL_TIME = 'ALL_TIME',
  WEEK = 'WEEK',
  DAY = 'DAY',
}
